import { Chip, useTheme } from '@mui/material';
import _ from 'lodash';
import React from 'react';
import { AttendanceStatus } from '../../../types/Event';
import { attendanceStatusColor } from '../../dashboard/EventsPanel/EventTile';

export default function AttendancePill({ status }: { status: AttendanceStatus | null }) {
  const theme = useTheme();
  if (!status) return '-';

  return <Chip label={_.startCase(status)} sx={{ bgcolor: attendanceStatusColor(status, theme) }} size="small" />;
}
